// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d8c8e5ad","453":"96453769"}[chunkId] + ".chunk.js";
};